import { useEffect, useState } from "react";
import useApi from "../customHooks/useAPI";
import { useAuth } from "../context/AuthContext";
import { generatePrescriptionPDF } from "../util/prescriptionPdfGenerator";

const AllPrescriptions = ({ patientId }) => {
    const { callApi } = useApi();
    const { doctorId } = useAuth();
    const [prescriptions, setPrescriptions] = useState([]);

    const fetchPrescriptions = async () => {
        const response = await callApi({
            url: `${process.env.REACT_APP_BACKEND_ENDPOINT}/common/prescriptions?doctorId=${doctorId}`,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "patient-id": String(patientId),
            },
        });

        if (response?.data) setPrescriptions(response.data);
    };

    useEffect(() => {
        if (patientId) fetchPrescriptions();
    }, [patientId]);

    const openPDF = async (prescription) => {
        await generatePrescriptionPDF(prescription);
    };

    return (
        <div className="reportContainer max-h-[50vh] overflow-scroll p-3">
            <div className="flex flex-col">
                {prescriptions.map((item) => (
                    <div
                        key={item.id}
                        className="p-3 border rounded-lg bg-white shadow hover:shadow-md transition-all cursor-pointer"
                        onClick={() => openPDF(item)}
                    >
                        <h4 className="text-sm font-bold text-gray-800">Prescription #{item.id}</h4>

                        <p className="text-xs text-gray-500">
                            <strong>Created:</strong>{" "}
                            {new Date(item.created_at).toLocaleString()}
                        </p>

                        <p className="text-xs text-gray-500">
                            <strong>Updated:</strong>{" "}
                            {new Date(item.updated_at).toLocaleString()}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AllPrescriptions;
